import { GET_PROJECT_CHILD_ITEM_CMS_API } from '../commons/constants';
import { ProjectChildItemTypes } from '../types';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchProjectChildItemsCms = async (request: {
  keyword?: string;
  projectId?: string | number;
  projectItemIds?: string;
  floorIds?: string;
}): Promise<PaginationResponseTypes<ProjectChildItemTypes[]>> => {
  let res: PaginationResponseTypes<ProjectChildItemTypes[]>;
  try {
    res = await get(`${GET_PROJECT_CHILD_ITEM_CMS_API}`, {
      params: { ...request, published: true },
    });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
